export default __webpack_public_path__ + "static/media/grafema_ciceco_08.0693fcae.jpg";